export const scheduling = {
  time: {
    today: 'Today',
    tomorrow: 'Tomorrow',
  },
};
